import { Box } from '@mui/material';
import { If } from 'src/components/If';
import { PanelLogin } from 'src/components/PanelLogin';
import Subtitle from 'src/components/Subtitle';
import { useAuthContext } from 'src/context/AuthContextProvider';

import { Timeline } from './Timeline';

type OperationTimelineProps = {
  hashId: string;
};

export function OperationTimeline({ hashId }: OperationTimelineProps) {
  const { auth } = useAuthContext();

  return (
    <Box p={2}>
      <Subtitle title="Linha do Tempo" />
      <Box>
        <If
          condition={
            !auth?.user?.subscription?.plan?.permissions?.linha_do_tempo
          }>
          <PanelLogin />
        </If>
        <If
          condition={
            auth?.user?.subscription?.plan?.permissions?.linha_do_tempo
          }>
          <Timeline hashId={hashId} />
        </If>
      </Box>
    </Box>
  );
}
